import { watch } from "vue"
import { createI18n } from "vue-i18n"
import en from "./locales/en.json"
import zh from "./locales/zh.json"

function getDefaultLocale() {
  const supportedLocales = ['zh', 'en']
  // 优先从 localStorage 读取用户之前的选择
  const stored = localStorage.getItem('locale')
  if (stored && supportedLocales.includes(stored)) return stored
  // 取浏览器系统语言
  const browserLang = navigator.language || navigator.userLanguage || ''
  const lang = browserLang.toLowerCase().split('-')[0]
  if (supportedLocales.includes(lang)) return lang
  // 默认英文
  return 'en'
}

const i18n = createI18n({
  legacy: false,
  fallbackLocale: 'en',
  locale: getDefaultLocale(),
  messages: {
    zh,
    en
  }
})

// 把当前语言同步到 <html lang>：既是无障碍/SEO 的基本要求，
// 也让各页面可以用 html[lang="en"] 单独为英文（文案更长）做排版适配
const syncHtmlLang = (value) => {
  if (typeof document !== 'undefined') document.documentElement.lang = value
}

syncHtmlLang(i18n.global.locale.value)
watch(i18n.global.locale, syncHtmlLang)

export default i18n
